import styles from '@/styles/hottest-deals/topSellers.module.scss'
import Image from 'next/image'
import Link from 'next/link'
import { useState } from 'react';
import MyTags from "@/components/MyTags"
import SwiperSelf from '@/components/SwiperSelf'
import { SwiperSlide } from 'swiper/react';

import getConfig from 'next/config'
const { publicRuntimeConfig } = getConfig()
const imageDomain = publicRuntimeConfig.imageDomain

interface ProductItem {
  productID: string;
  name: string;
  url: string;
  imgUrl: string;
  price: number;
  normalPrice: number;
  freeShipping: number;
  onSale: number;
  reduced: number;
  isNew: number;
  position?: number,
  location?: string;
  isEmailOnly: any,
  promotionTypeID: string | number;
  promotion: {
    productID: number;
    promotionType: number;
    promotionPrice: number;
    normalPrice: number;
    endDate: string;
    status: number;
    notified: number;
    pointRate: string;
    promotionRate: number;
  };
}

interface TopSellersProps {
  topSellers: ProductItem[];
}

interface ProductItemProps {
  item: ProductItem;
}

const TopSellersProductItem: React.FC<ProductItemProps> = ({ item }) => {
  // 价格处理
  let price = `${Number(item.normalPrice).toFixed(2)}`.split('.')
  if (item.price && item.price != item.normalPrice) {
    price = `${Number(item.price).toFixed(2)}`.split('.')
  }

  return (
    <Link
      href={item.url}
      legacyBehavior
    >
      <a rel="noopener noreferrer">
        <div className={styles['product-item']}>
          <div className={styles['image-box']}>
            <Image
              className={styles['product-image']}
              src={item.imgUrl}
              alt={item.name}
              priority={true}
              width={216}
              height={216}></Image>
              
            {
              !!(item?.promotion.promotionRate)
              &&
              <div className={styles['promotion-rate-box']}>
                {item.promotion?.promotionRate}% OFF
              </div>
            }
          </div>

          <div className={styles['product-info']}>
            <div className={styles['product-name']}>{item.name}</div>
            <MyTags {...item} />

            <div className={styles['price-title']}>Crazy Price:</div>
            <div className={styles['price-info']}>
              <div className={styles['promotion-price']}>
                $<b>{price[0]}<i>.{price.length === 2 ? price[1] : '00'}</i></b>
              </div>

              <div className={styles['normal-price']}>Was:${item.normalPrice}</div>
            </div>
          </div>
        </div>
      </a>
    </Link>
  );
};

export default function CrazyTopSellers(props: TopSellersProps) {

  // swiper轮播图的index
  const [activeIndex, setActiveIndex] = useState(0)
  function onSlideChange(isBeginning: boolean, isEnd: boolean, activeIndex: number) {
    setActiveIndex(activeIndex)
  }

  return (
    <>
      <div className={styles['top-sellers-box']}>
        <div className={styles['count-down-box']}>
          <Link
            href={props.topSellers[activeIndex]?.url || ''}
            legacyBehavior
          >
            <a rel="noopener noreferrer">
              <Image
                className={styles['count-down-banner']}
                src={`${imageDomain}/hottest-deals/crazy-top-sellers.jpg`}
                alt={'banner'}
                width={470}
                height={100}></Image>
            </a>
          </Link>
        </div>

        <div className={styles['sellers-box']}>
          {
            !!(props?.topSellers && props.topSellers.length) &&
            <SwiperSelf
              slidesPerView={1}
              pagination={true}
              loop={true} 
              autoplay={true} 
              delay={4000}
              hoverShowArrows={true}
              slideChange={onSlideChange} 
            >
              {
                props.topSellers?.map((item: ProductItem, index:number) => (
                  <SwiperSlide key={index}>
                    <TopSellersProductItem item={item}></TopSellersProductItem>
                  </SwiperSlide>
                ))
              }
            </SwiperSelf>
          }
        </div>
      </div>
    </>
  )
}